import { atom } from 'recoil';

export const cashName = atom({
  key: 'cashName',
  default: undefined,
});
